export enum EnhancementStatus {
	Ok = 'ok',
	Failed = 'failed',
}
